import axios from "axios";

export default {
  namespaced: true,
  state: {
    itemgroups: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    itemgroupsMessage: ''
  },
  mutations: {
    RECEIVED_GROUPS(state, payload) {
      state.itemgroups = payload;
      state.isReceiving = false;
    },
    RECEIVING_GROUPS(state) {
      state.isReceiving = true;
    },
    RECEIVED_GROUP(state, payload) {
      console.log("RECEIVED GROUP", payload);
      state = Object.assign(state, {
        itemgroups: [...state.itemgroups, payload],
        isReceiving: false,
      })
    },
    RECEIVING_GROUP(state) {
      state.isReceiving = true;
    },
    UPDATED_GROUP(state, payload) {
      console.log(state.itemgroups);
      console.log(payload);
      let index = state.itemgroups.findIndex(itemgroup => itemgroup._id === payload._id);
      state = Object.assign(state, {
        itemgroups: state.itemgroups.map((itemgroup, i) => {
          if (i === index) {
            return Object.assign({}, itemgroup, payload);
          }
          return itemgroup;
        }),
        isUpdating: false,
        itemgroupsMessage: 'ItemGroups has been updating!',
      })
    },
    UPDATING_GROUP(state) {
      state.isUpdating = true;
    },
    DELETED_GROUP(state, payload) {
      let indexToDelete = state.itemgroups.findIndex(itemgroup => itemgroup._id === payload._id);
      console.log(indexToDelete);
      let itemgroups = [...state.itemgroups];
      itemgroups.splice(indexToDelete, 1);
      state = Object.assign(state, {
        itemgroups: [...itemgroups],
        isDeleting: false,
        idToDelete: null,
        itemgroupsMessage: 'ItemGroup has been Deleted!',
      });
    },
    DELETING_GROUP(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getItemGroupsRequest({dispatch}) {
      dispatch("receivingItemGroups");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/itemgroups';
      var header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      var get = {
        method: "get",
        url: url,
        headers: header,
      };
      axios(get).then(res => {
        console.log("HERE", res.data);
        dispatch("receiveItemGroups", res.data);
      })
    },
    loadItemGroupRequest({dispatch}, id) {
      dispatch("receivingItemGroup");
      axios.get('/itemgroups/' + id).then(res => {
        dispatch("receiveItemGroup", res.data);
      })
    },
    updateItemGroupRequest({dispatch}, payload) {
      dispatch("updatingItemGroup");
      let id = payload._id;
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/itemgroup/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
    
      axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateItemGroup", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateItemGroupImageRequest({dispatch}, payload) {
      dispatch("updatingItemGroup");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/itemgroup/image/' + id;
      let data = new FormData();
      data.append('image', payload.itemgroupimage, payload.imagename); 
      delete payload['itemgroupimage'];
      for (let x in payload) {data.append(x, payload[x])}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};

      axios({method: "PUT", url: url, headers: headers, data: data})
      .then(function (res) {
        dispatch("updateItemGroup", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createItemGroupRequest({dispatch}, payload) {
      dispatch("receivingItemGroups");
      var url;
      var data;
      var header;
      var token = localStorage.getItem('token');

      if(payload.itemgroupimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/itemgroup/withimage';
        data = new FormData();
        data.append('image', payload.itemgroupimage, payload.imagename); 
        delete payload['itemgroupimage'];
        for (let x in payload) {
          data.append(x, payload[x]);
        }
        header = {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + token
        };
      } else {
        url = 'https://api.tradexc.com:3000/insert/itemgroup';
        data = payload;
        header = {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        };
      }
      var post = {
        method: "post",
        url: url,
        headers: header,
        data: data,
      };
      axios(post)
      .then(function (res) {
        console.log(res);
        dispatch("receiveItemGroup", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteItemGroupRequest({dispatch}, payload) {
      dispatch("deletingItemGroup", payload);
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let url = 'https://api.tradexc.com:3000/delete/itemgroup/' + payload._id;
      
      axios({method: 'DELETE', url: url, headers: headers})
      .then(() => {
        dispatch("deleteItemGroup", {_id: payload._id});
      })
    },
    receiveItemGroups({commit}, payload) {
      commit("RECEIVED_GROUPS", payload)
    },
    receivingItemGroups({commit}) {
      commit("RECEIVING_GROUPS")
    },
    receiveItemGroup({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_GROUP", payload)
    },
    receivingItemGroup({commit}) {
      commit("RECEIVING_GROUP")
    },
    updateItemGroup({commit}, payload) {
      commit("UPDATED_GROUP", payload)
    },
    updatingItemGroup({commit}) {
      commit("UPDATING_GROUP")
    },
    deleteItemGroup({commit}, payload) {
      commit("DELETED_GROUP", payload)
    },
    deletingItemGroup({commit}, payload) {
      commit("DELETING_GROUP", payload)
    }
  },
};
